import "firebase/auth";
import firebase from "firebase/app";

const provider = new firebase.auth.GoogleAuthProvider();

export default provider;